import { Injectable } from '@angular/core';

import { LinearDetailsComponent } from 'app/locations/details/linear/linear-details.component';
import { PointDetailsComponent } from 'app/locations/details/point/point-details.component';
import { LinearInsertComponent } from 'app/locations/insert/linear/linear-insert.component';
import { PointInsertComponent } from 'app/locations/insert/point/point-insert.component';

@Injectable()
export class ErrorService {
  linearInsertComponent: LinearInsertComponent;
  pointInsertComponent: PointInsertComponent;

  linearDetailsComponent: LinearDetailsComponent;
  pointDetailsComponent: PointDetailsComponent;
}



// WEBPACK FOOTER //
// ./src/app/services/error.service.ts